var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, } from "react";
import classNames from "classnames";
import { PillSize, PillType } from "./types";
export const Pill = forwardRef((_a, ref) => {
    var { children, className, iconLeft, iconRight, size = PillSize.Small, type = PillType.Default, listboxId, disabled, ellipsisBreakpoint = typeof children === "string" ? "120px" : "100vw", onClick } = _a, props = __rest(_a, ["children", "className", "iconLeft", "iconRight", "size", "type", "listboxId", "disabled", "ellipsisBreakpoint", "onClick"]);
    const onClickHandler = () => {
        if (onClick)
            onClick();
    };
    const role = onClick ? "button" : undefined;
    const ariaControls = listboxId ? `listbox-${listboxId}` : undefined;
    return (React.createElement("div", { ref: ref, style: { "--ellipsis-breakpoint": ellipsisBreakpoint }, className: classNames("gerudo-pill", type, size, className, { "with-icon": iconLeft || iconRight }), onClick: onClickHandler, "data-testid": props === null || props === void 0 ? void 0 : props["data-testid"], role: role, title: typeof children === "string" ? children : undefined, "aria-controls": ariaControls, "aria-disabled": disabled },
        iconLeft && React.createElement("span", { className: "gerudo-pill-icon-left" }, iconLeft),
        React.createElement("span", { className: "gerudo-pill-text" }, children),
        iconRight && React.createElement("span", { className: "gerudo-pill-icon-right" }, iconRight)));
});
Pill.displayName = "Pill";
export default Pill;
//# sourceMappingURL=Pill.js.map